import React from 'react';
import { useNavigate } from 'react-router';
import { useApptekster } from '../../contexts/ApptekstContext';
import { AktivSakStatus, DineSkiltSakStatus, SakStatus } from '../../utils/api';
import { Paragraph } from '../../components/Paragraph';
import { useSkiltbestillingState } from '../skiltbestilling/Skiltbestilling';
import { SVVButton } from '@komponentkassen/svv-button';

type BestillSkiltStegProps = {
    rettighetId: number;
    sakStatus: SakStatus;
    tegnkombinasjon: string;
};

export const BestillSkiltSteg: React.FC<BestillSkiltStegProps> = ({
    rettighetId,
    sakStatus,
    tegnkombinasjon,
}) => {
    const t = useApptekster();
    const navigate = useNavigate();
    const setRettighetId = useSkiltbestillingState(
        (state) => state.setRettighetId,
    );
    const setTegnkombinasjon = useSkiltbestillingState(
        (state) => state.setTegnkombinasjon,
    );

    switch (sakStatus) {
        case AktivSakStatus.MOTTATT:
        case AktivSakStatus.UNDER_BEHANDLING:
        case AktivSakStatus.INNVILGET:
            return (
                <li className="statusliste__steg">
                    <h3 className="svv-h5">
                        {t('personlig-kjennemerke.status.bestill-skilt')}
                    </h3>
                </li>
            );
        case AktivSakStatus.BETALT:
            return (
                <li className="statusliste__steg aktiv">
                    <h3 className="svv-h5 svv-h5--spacing">
                        {t('personlig-kjennemerke.status.bestill-skilt')}
                    </h3>
                    <Paragraph>
                        {t(
                            'personlig-kjennemerke.status.bestill-skilt.ingress',
                        )}
                    </Paragraph>
                    <div className="button-row">
                        <SVVButton
                            onClick={() => {
                                setRettighetId(`${rettighetId}`);
                                setTegnkombinasjon(tegnkombinasjon);
                                navigate(`/skiltbestilling`);
                            }}
                        >
                            {t('personlig-kjennemerke.status.bestill-skilt')}
                        </SVVButton>
                    </div>
                </li>
            );
        case AktivSakStatus.SKILT_BESTILT:
        case AktivSakStatus.SKILT_BESTILT_BRUKER:
            return (
                <li className="statusliste__steg aktiv">
                    <h3 className="svv-h5 svv-h5--spacing">
                        {t(
                            'personlig-kjennemerke.status.bestill-skilt.har-bestilt',
                        )}
                    </h3>
                    <p>
                        {t(
                            'personlig-kjennemerke.status.bestill-skilt.har-bestilt.ingress',
                        )}
                    </p>
                </li>
            );
        case AktivSakStatus.SKILT_MOTTATT:
        case DineSkiltSakStatus.SKILT_UTLEVERT:
        case DineSkiltSakStatus.KNYTTET:
            return (
                <li className="statusliste__steg fullfort">
                    <h3 className="svv-h5">
                        {t(
                            'personlig-kjennemerke.status.bestill-skilt.har-bestilt',
                        )}
                    </h3>
                </li>
            );
        default:
            return <></>;
    }
};
